

export const apiAssets = {
    salesImportUpload: "/api/InvoiceImport",
    salesYearlyTarget: "api/SalesTarget",
    employeeList: "/GetEmployees",
    saveEmployee:"api/Employee",
    employeeDetails: "/GetEmployeeDetails",
    financialYearList: "/GetFinancialYear",
    employeeTarget: "api/EmployeeTarget",
    getEmployeeTarget: "/GetEmployeeTarget",
    login: 'api/Account/Login',
    forgotPassword: 'api/Account/ForgotPassword',
    changePassword: 'api/Account/ChangePassword',
    outstandingImportUpload: "/api/OutStandingImport",
    outstandingList: "/GetEmployeeOutstanding",
    salesInvoiceList:"api/InvoiceImport"
}

export const alertMessages = {
    loginFailure: "Sorry, the username or password you entered is incorrect. Please double-check your information and try again.",
    passwordChangeFailures: "Your old password is wrong. Please double-check your information and try again.",
    passwordChangeSuccess: "Awesome! Your Password has been successfully updated.",
    newPassError: "New passwords must be at least eight characters long and include at least one capital letter and one special character.",
    resetPasswordSuccessMessage: "Great! Your password has been reset successfully.",
    resetPasswordFailureMessage: "Uh-oh, it seems the password reset token has expired or the username you entered is invalid. Please try again.",
    forgotPasswordSuccessMessage: "Great! The reset link has been sent to your email. Please check your email and use the link to reset your password.",
    invalidUserInDB: "The email provided is not found in our database. It appears to be an invalid email. Please provide a valid email address.",
    mailNotSent: "The provided username is valid. Unfortunately, the reset link was not sent to your email. Please try again after some time.",
    deleteFavorite: 'Are you sure you want to remove this record from favorite?',
    deleteReviewReply: 'Are you sure you want to delete this?',
    deleteFavorite: 'Are you sure you want to remove this record from favorite?.',
    myProfileMobileUpdate: 'Awesome! Your Mobile Number has been successfully updated.',
    leadRegisterSuccess: 'Awesome! Your details has been successfully updated.',
    myProfileGetFailure: 'Sorry, unable to retrieve your profile details. Please try again later or contact the administration for assistance.',
    myProfileUpdateFailure: 'Sorry, unable to update your profile details. Please try again later or contact the administration for assistance.',
    alreadyRegisterWarning: 'Your request is already in progress. Our representative will reach out to you shortly.'
}

export const loginStaorageKey = 'loginToken';

export const userEmailKey = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress";